import { defineMessages } from 'react-intl';

export default defineMessages({
    editDriverPopupTitle_Ext: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.edit.Edit driver',
        defaultMessage: 'Edit driver'
    },
    DOBTooltipContent_Ext: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.edit.Date of Birth Tooltip Content',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    },
    saveEditLabel_Ext: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.edit.Save',
        defaultMessage: 'Save'
    },
    cancelLabel_Ext: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.edit.Cancel',
        defaultMessage: 'Cancel'
    }
});
